/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-datetime';
import ToggleControl from 'app/components/common/ToggleControl.jsx';

class EverqueueControls extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            postAndQueue: false,
            useEndDate: false,
            endDate: null,
            endTime: null,
            errors: []
        };

        this.addToEverqueue = this.addToEverqueue.bind(this);

    }

    addToEverqueue() {
        let endTimestamp = 0,
            nextErrors = [],
            selectedDate = null;

        // the pickers hand back a moment for something they can read, and the typed text otherwise
        const isDate = (value) => moment.isMoment(value) && value.isValid();

        if (this.state.useEndDate) {
            if (isDate(this.state.endDate)) {
                selectedDate = new moment(this.state.endDate).tz(this.props.user.detail.timezone);
                if (isDate(this.state.endTime)) {
                    selectedDate.hour(this.state.endTime.hour());
                    selectedDate.minutes(this.state.endTime.minutes());
                    selectedDate.seconds(this.state.endTime.seconds());
                }
            }

            if (selectedDate === null) {
                nextErrors.push({endDate: 'Please choose a date when we should stop posting this item.'});
            } else if (!selectedDate.isAfter(new moment())) {
                nextErrors.push({endDate: 'Please choose a date in the future for your Everqueue item to expire.'});
            }
        }

        // checked afresh on every click, so a repeat click can't slip past an error already showing
        this.setState({
            errors: nextErrors
        });
        if (nextErrors.length) {
            return;
        }

        if (selectedDate) {
            endTimestamp = selectedDate.format("X");
        }

        this.props.confirmAction(this.state.postAndQueue, endTimestamp);
    }

    render() {
        let buttonLabel = 'Add to Everqueue',
            disabled = (this.state.useEndDate) ? false : true;

        const hasError = (field) => {
            let hasError = false;

            this.state.errors.map((error) => {
                if (error[field] !== undefined) {
                    hasError = true;
                }
            });

            return hasError;
        };

        const updateDate = (nextDate, field) => {
            let nextState = Object.assign({}, this.state);

            nextState[field] = nextDate;

            this.setState(nextState);
        };

        if (this.state.postAndQueue) {
            buttonLabel = 'Post now & Add to Everqueue';
        }

        return (
            <div>
                <div className="pt-everqueue">
                    <div className="everqueue-options">
                        <div className="option-toggle">
                            <ToggleControl
                                activeLabel="Post now and Add to Everqueue"
                                inactiveLabel="Post now and Add to Everqueue"
                                active={this.state.postAndQueue}
                                callback={(e) => {
                                    let active = e.currentTarget.dataset.togglestate,
                                        nextPostAndQueue = true;

                                    if (active === 'true') {
                                        nextPostAndQueue = false
                                    }

                                    this.setState({
                                        postAndQueue: nextPostAndQueue
                                    });
                                }}/>
                        </div>
                        <div className="option-toggle">
                            <ToggleControl
                                activeLabel="Do not post item after"
                                inactiveLabel="Do not post item after"
                                active={this.state.useEndDate}
                                callback={(e) => {
                                    let active = e.currentTarget.dataset.togglestate,
                                        nextUseEndDate = true;

                                    if (active === 'true') {
                                        nextUseEndDate = false
                                    }

                                    this.setState({
                                        useEndDate: nextUseEndDate
                                    });
                                }}/>
                        </div>
                    </div>
                    <div className="end-date-controls">
                        <fieldset>
                            <div className="inline-label">
                                End Date
                            </div>
                            <DateTimePicker
                                inputProps={{
                                    placeholder: "End Date",
                                    className: `text-input ${hasError('endDate') ? 'error' : ''}`,
                                    disabled: disabled
                                }}
                                timeFormat={false}
                                onChange={(newTime) => {
                                    updateDate(newTime, 'endDate');
                                }}
                                closeOnSelect={true}
                                value={this.state.endDate}
                                displayTimeZone={this.props.user.detail.timezone}/>
                            <DateTimePicker
                                inputProps={{
                                    placeholder:"End Time",
                                    className: `text-input ${hasError('endTime') ? 'error' : ''}`,
                                    disabled: disabled
                                }}
                                dateFormat={false}
                                onChange={(newTime) => {
                                    updateDate(newTime, 'endTime');
                                }}
                                closeOnSelect={true}
                                value={this.state.endTime}
                                displayTimeZone={this.props.user.detail.timezone}/>
                        </fieldset>
                    </div>
                    {this.state.errors.length ? (
                        <ul className="pt-service-errors">
                            {this.state.errors.map((error) => {
                                let key = Object.keys(error);
                                return (
                                    <li key={`error-schedule-${key}`} className="post-error">
                                        <i className="icon ion-android-alert"></i>{error[key]}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : null}
                    <div className="twitter-warning">
                        <a href="https://support.dlvrit.com/hc/en-us/articles/360002116333" target="_blank"><em>EverQueue content for Twitter will be retweeted per their policy update.</em></a>
                    </div>
                </div>
                <div className="pt-accessory-actions">
                    <div role="button" className="action-cancel" onClick={this.props.cancelAction}>
                        Go Back
                    </div>
                    <button type="button" className="btn-delete action-delete" onClick={this.addToEverqueue}>
                        {buttonLabel}
                    </button>
                </div>
            </div>
        );
    }
}

EverqueueControls.displayName = "EverqueueControls";

export default EverqueueControls;
